import { Config } from '../objects/config';

export const SET_CONFIG = 'SET_CONFIG';

interface SetConfigAction {
    type: typeof SET_CONFIG,
    payload: Config
}

export type HeaderActionTypes = SetConfigAction;